/* globals _ */

const config = require("config");

(function () {
  "use strict";
  angular
    .module("alk.places")
    .factory("placeCloudService", placeCloudService);
  placeCloudService.$inject = ["$http", "$q", "mapUtilities", "UserProvider", "PCMRegion"];

  function placeCloudService($http, $q, mapUtilities, UserProvider, PCMRegion) {

    var daUrl = config.daUrl;

    // pchen: temp default params for yard gate notes (since no UI for them)
    const DEFAULT_NOTE_FLAGS = {
      "TriggerDistance": 250,
      "NoteTitle": "",
      //"Sequence": 0,
      //"Active": true,
      "TravelIntent": 0,
      "AlertType": 3
    };

    const COMPANY_PLACES_TYPE_ID = 1803;

    return {
      getPlaceSetWithName: getPlaceSetWithName,
      getPlaceSets: getPlaceSets,
      addPlaceSet: addPlaceSet,
      addCategoryForSet: addCategoryForSet,
      getCategoryForSet: getCategoryForSet,
      getCategoryIcons: getCategoryIcons,
      getCategoryDefaultIcon: getCategoryDefaultIcon,
      updateCategoryForSet: updateCategoryForSet,
      deletePlaceSet: deletePlaceSet,
      updatePlaceSet: updatePlaceSet,
      getPlaces: getPlaces,
      getPlaceByPlaceId: getPlaceByPlaceId,
      testCompanyIds: testCompanyIds,
      saveNewPlace: saveNewPlace,
      saveNewPlaces: saveNewPlaces,
      deletePlace: deletePlace,
      deletePlaces: deletePlaces,
      updatePlace: updatePlace,
      movePlaces: movePlaces,
      getYardByYardId: getYardByYardId,
      addYard: addYard,
      deleteYard: deleteYard,
      addPlaceToYard: addPlaceToYard,
      removeYardFromPlace: removeYardFromPlace,
      addYardGate: addYardGate,
      addYardGates: addYardGates,
      deleteYardGate: deleteYardGate,
      getYardGates: getYardGates,
      parseGateResponse: parseGateResponse,
      updateYard: updateYard,
      updateYardGate: updateYardGate,
      getYardGateNote: getYardGateNote,
      addYardGateNote: addYardGateNote,
      updateYardGateNote: updateYardGateNote,
      deleteYardGateNote: deleteYardGateNote,
      getYardGatePath: getYardGatePath,
      addYardGatePath: addYardGatePath,
      updateYardGatePath: updateYardGatePath,
      deleteYardGatePath: deleteYardGatePath,
      createUniqueId: createUniqueId,
      // TODO pchen: move to separate file specifically for DA routing-profiles
      getRoutingProfileList: getRoutingProfileList
    };

    //Check if a place set with name (exact match) exists.
    // pchen: only used in PCMWeb so far, for favorites
    function getPlaceSetWithName(name, {onlyMine = true, useShared = false} = {}) {
      var params = {
        "includePlaces": false,
        "onlyMine": onlyMine,
        "useShared": useShared,
        "name": name,
        // if true, include ALK public sets in response
        "readOnlyPublicData": false
      };

      var request = {
        method: "GET",
        url: daUrl + "place-sets/-1",
        params: params
      };

      return $http(request)
        .then(function (response) { //success
          return response.data;
        }, function (response) { //fail
          console.log(response);
          return null;
        });
    }

    function getPlaceSets(filter) {

      var promises = [];
      //Not an admin, don't show private
      if (!UserProvider.getUser() || !UserProvider.getUser().roles || UserProvider.getUser().roles.indexOf("ALK Administrator") === -1) {
        //Get Favorites
        var userPromise = $http.get(daUrl + "place-sets/-1?getSetOptions=true&includePlaces=false&onlyMine=True&useShared=False&readOnlyPublicData=True&nameFilter=" + (filter || ""));
        var accountPromise = $http.get(daUrl + "place-sets/-1?getSetOptions=true&includePlaces=false&onlyMine=True&useShared=True&readOnlyPublicData=True&nameFilter=" + (filter || ""));
        promises = [userPromise, accountPromise];
        return $q.all(promises).then(function (sets) {
          var onlyMine = sets[0].data; // User's private sets.
          var onlyShared = sets[1].data; // All shared sets. (Does not include user's private or anyone else's)
          return _.union(onlyMine, onlyShared, "Name");
        }, function (response) {
          console.log(response);
          return null;
        });
      }
      //An admin, show all (including private)
      else {
        return $http.get(daUrl + "place-sets/-1?getSetOptions=true&includePlaces=false&onlyMine=false&useShared=true&readOnlyPublicData=True&nameFilter=" + (filter || "")).then(function (set) {
          return set.data;
        }, function (response) {
          console.log(response);
          return null;
        });

      }

    };

    function defaultErrorHandler(response) {
      console.log(response);
      return null;
    }

    function addPlaceSet(setName, errorHandler, isShared, setOptions, setStyle) {

      //Default to shared
      if (isShared === undefined) {
        isShared = true;
      }

      var params = {
        "useShared": isShared
      };
      var postData = {
        Name: setName,
        Style: JSON.stringify(setStyle),
        Options: setOptions ? setOptions : {
          DisplayOnMap: true,
          Searchable: true,
          Alertable: true
        }
      };

      var request = {
        method: "POST",
        url: daUrl + "place-sets",
        params: params,
        data: postData
      };

      const respErrorHandler = errorHandler || defaultErrorHandler;

      return $http(request)
        .then(function (response) { //success
          return response.data;
        }, respErrorHandler);
    }

    function deletePlaceSet(setId) {
      var request = {
        method: "DELETE",
        url: daUrl + "place-sets/" + setId
      };

      return $http(request)
        .then(function (response) { //success
          return response.data;
        }, function (response) { //fail
          console.log(response);
          return null;
        });
    };

    function updatePlaceSet(setId, setName, setStyle, errorHandler, setOptions) {
      var putData = {
        Name: setName,
        Style: JSON.stringify(setStyle),
      };

      if (setOptions) {
        putData.Options = setOptions;
      }

      var params = {
        "useShared": true
      };

      var request = {
        method: "PUT",
        url: daUrl + "place-sets/" + setId,
        params: params,
        data: putData
      };

      const respErrorHandler = errorHandler || defaultErrorHandler;

      return $http(request)
        .then(function (response) { //success
          return response.data;
        }, respErrorHandler);
    };

    function getCategoryOptionsFromSetOptions(setOptions) {
      var TypeOption_None = 0x0000;
      var TypeOption_DisplayOnMap = 0x0001;
      var TypeOption_DisplayInWalkMode = 0x0002;
      var TypeOption_Searchable = 0x0004;
      var TypeOption_GroupableOnMap = 0x0008;
      var TypeOption_Alertable = 0x0010;

      var catOptions = TypeOption_None;
      if (setOptions) {
        if (setOptions.DisplayOnMap)
          catOptions = catOptions | TypeOption_DisplayOnMap;
        if (setOptions.Searchable)
          catOptions = catOptions | TypeOption_Searchable;
        if (setOptions.Alertable)
          catOptions = catOptions | TypeOption_Alertable;
      } else {
        catOptions = TypeOption_DisplayOnMap | TypeOption_Searchable | TypeOption_Alertable;
      }

      return catOptions;
    }

    function getCategoryDefaultMaxZoomLevel() {
      return 4;
    }

    function updateCategoryForSet(category, setOptions) {
      var catOptions = getCategoryOptionsFromSetOptions(setOptions);
      var catPostData = {
        Icon: category.Icon,
        IconUrl: category.IconURL,
        Name: category.Name,
        MaxZoomLevel: category.MaxZoomLevel,
        Options: catOptions,
        ParentId: category.ParentId,
        ClientParentId: COMPANY_PLACES_TYPE_ID,
        SetId: category.SetId
      };

      var catRequest = {
        method: "PUT",
        url: daUrl + "place-categories/" + category.Id,
        params: null,
        data: catPostData
      };

      const respErrorHandler = defaultErrorHandler;

      return $http(catRequest)
        .then(function (response) { //success
        }, respErrorHandler);
    }

    function getCategoryForSet(set) {
      if (set == null) {
        var deferred = $q.defer();
        deferred.resolve(-1);
        return deferred.promise;
      } else if (set.Categories && set.Categories.length > 0) {
        var deferred = $q.defer();
        deferred.resolve(set.Categories[0].Id);
        return deferred.promise;
      } else {
        return addCategoryForSet(set.Name, set.Id, set.Options).then(function (response) {
          return response.Id;
        });
      }
    }

    function addCategoryForSet(setName, setId, setOptions, icon) {
      icon = icon || getCategoryDefaultIcon().Icon; // default if undefined
      var catOptions = getCategoryOptionsFromSetOptions(setOptions);
      var catPostData = {
        Icon: icon,
        IconUrl: null,
        Name: setName,
        MaxZoomLevel: getCategoryDefaultMaxZoomLevel(),
        Options: catOptions,
        ParentId: null,
        ClientParentId: COMPANY_PLACES_TYPE_ID,
        SetId: setId
      };

      var catRequest = {
        method: "POST",
        url: daUrl + "place-categories?updatePlaces=true",
        params: null,
        data: catPostData
      };

      const respErrorHandler = defaultErrorHandler;

      return $http(catRequest)
        .then(function (response) { //success
          return response.data;
        }, respErrorHandler);
    }

    /**
     * Get set details and all places details.
     *  Note: yardId field in response is deprecated in server side. We will use SiteId field value.
     *  However to follow naming convention still called it yardId here.
     * @param {Number} setId
     * @param {String} filter
     * @param {Boolean} includePlaces
     * @param {Boolean} readOnlyPublicData
     */
    function getPlaces(setId, filter, includePlaces, readOnlyPublicData = true) {
      var params = {
        "includePlaces": (includePlaces == null) ? true : includePlaces,
        "onlyMine": false,
        "useShared": true,
        // if true and set is ALK Public, return the set (instead of "DataAccessException")
        "readOnlyPublicData": readOnlyPublicData,
        "placeNameFilter": filter || ""
      };

      var request = {
        method: "GET",
        url: daUrl + "place-sets/" + setId,
        params: params
      };

      return $http(request)
        .then(function (response) { //success
          var res = response.data[0];
          var places = res.Places;
          if (places != null && places.length > 0) {
            _.each(places, function (p) {
              p.YardId = p.SiteId;
              delete p.SiteId;
            });
          }
          return res;
        }, function (response) { //fail
          console.log(response);
          return null;
        });
    };

    /**
     * Get places details given the place Id.
     *  Note: yardId field in response is deprecated in server side. We will use SiteId field value.
     *  However to follow naming convention still called it yardId here.
     * @param {Number} placeId
     * @param {Boolean} readOnlyPublicData
     */
    function getPlaceByPlaceId(placeId, readOnlyPublicData = true) {
      var params = {
        // if true and place is ALK Public, return the place instead of "DataAccessException"
        "readOnlyPublicData": readOnlyPublicData
      };

      var request = {
        method: "GET",
        url: daUrl + "places/" + placeId,
        params: params
      };

      return $http(request)
        .then(function (response) { //success
          var res = response.data;
          res[0].YardId = res[0].SiteId;
          delete res[0].SiteId;
          return res;
        }, function (response) { //fail
          console.log(response);
          return null;
        });
    };

    function getPlacePostData(setId, catId, place) {
      //Guard against null values by defaulting to empty string
      _.each(place, function (value, key) {
        if (value === null || value === undefined) {
          place[key] = "";
        }
      });
      var address = {
        StreetAddress: place.street,
        City: place.city,
        State: place.state.toUpperCase(), //State abbreviations should be capitalized
        Zip: place.zip,
        County: place.county,
        Country: place.country
      };
      var coords = {
        Lat: place.latitude,
        Lon: place.longitude
      };

      var postData = {
        Address: address,
        CategoryId: catId,
        CompanyId: place.companyId,
        Coords: coords,
        PlaceName: place.placeName,
        Phone: place.phone,
        SetId: setId,
        Info: place.info
      };
      return postData;
    };

    // see if CID already exists in database (for this account)
    //  returns CIDs that would conflict
    function testCompanyIds(cidList) {
      var request = {
        method: "POST",
        url: daUrl + "places/id-test",
        data: cidList
      }

      return $http(request)
        .then(function (response) { //success
          return response.data;
        }, function (response) { //fail
          console.log(response);
          return null;
        });
    };

    function saveNewPlace(setId, catId, place) {
      var placePostData = getPlacePostData(setId, catId, place);

      var request = {
        method: "POST",
        url: daUrl + "places",
        data: placePostData
      };

      return $http(request)
        .then(function (response) { //success
          return response.data;
        }, function (response) { //fail
          console.log(response);
          return null;
        });
    };

    //See getPlacePostData for each object's expected properties in places array argument
    function saveNewPlaces(setId, catId, places) {
      if (places.length === 0) {
        return Promise.resolve(true);
      }
      var postData = [];
      _.each(places, function (place) {
        var placeData = getPlacePostData(setId, catId, place);
        postData.push(placeData);
      });

      var request = {
        method: "POST",
        url: daUrl + "places_multiple?setId=" + setId.toString() + "&catId=" + catId.toString(),
        data: postData
      };

      return $http(request)
        .then(function (response) { //success
          return response.data;
        }, function (response) { //fail
          console.log(response);
          return null;
        });
    };

    function deletePlace(placeId) {
      var request = {
        method: "DELETE",
        url: daUrl + "places/" + placeId
      };

      return $http(request)
        .then(function (response) { //success
          return response.data;
        }, function (response) { //fail
          console.log(response);
          return null;
        });
    };

    function deletePlaces(placeIdList) {
      //If no places in list, just resolve promise to true immediately
      if (placeIdList.length === 0) {
        return Promise.resolve(true);
      }

      for (var i = 0; i < placeIdList.length; i++) {
        placeIdList[i] = placeIdList[i].toString();
      }

      var request = {
        method: "POST",
        url: daUrl + "places/delete/multiple",
        data: placeIdList,
      };

      return $http(request)
        .then(function (response) { //success
          return response.data;
        }, function (response) { //fail
          console.log(response);
          return null;
        });

    };

    function updatePlace(placeObj) {
      var request = {
        method: "PUT",
        url: daUrl + "places/" + placeObj.Id,
        data: placeObj
      };

      return $http(request)
        .then(function (response) { //success
          return response.data;
        }, function (response) { //fail
          console.log(response);
          return null;
        });
    };

    function movePlaces(placeIds, destinationSet, catId) {

      var request = {
        method: "PUT",
        url: daUrl + "place-sets/" + destinationSet + "/places",
        data: placeIds
      };

      if (catId)
        request.url += "?newCatId=" + catId;

      return $http(request)
        .then(function (response) { //success
          return response.data;
        }, function (response) { //fail
          console.log(response);
          return null;
        });
    };

    function getCategoryIcons() {
      return [
        {
          color: "#B84A00",
          shape: "circle",
          Icon: "truck",
          name: "Truck Services"
        },
        {
          color: "#123EC4",
          shape: "circle",
          Icon: "auto_rental",
          name: "Vehicle Dealership & Repair"
        },
        {
          color: "#1E834C",
          shape: "circle",
          Icon: "entertainment",
          name: "Entertainment"
        },
        {
          color: "#1E834C",
          shape: "circle",
          Icon: "retail",
          name: "Retail"
        },
        {
          color: "#f78d28",
          shape: "circle",
          Icon: "restaurant",
          name: "Restaurant"
        },
        {
          color: "#123EC4",
          shape: "circle",
          Icon: "parking",
          name: "Parking & Rest Area"
        },
        {
          color: "#00BAAE",
          shape: "circle",
          Icon: "other",
          name: "Other"
        },
        {
          color: "#E63D00",
          shape: "circle",
          Icon: "medical",
          name: "Medical & Emergency"
        },
        {
          color: "#913D88",
          shape: "circle",
          Icon: "hotel",
          name: "Hotel & Accommodation"
        },
        {
          color: "#450DBD",
          shape: "circle",
          Icon: "fuel",
          name: "Gas Station"
        },
        {
          color: "#123EC4",
          shape: "circle",
          Icon: "charging_station",
          name: "Electric Vehicle Charging Station"
        },
        {
          color: "#B84A00",
          shape: "circle",
          Icon: "distribution_center",
          name: "Distribution Center"
        },
        {
          color: "#1E834C",
          shape: "circle",
          Icon: "bank",
          name: "Bank & ATM"
        },
        {
          color: "#123EC4",
          shape: "circle",
          Icon: "airport",
          name: "Airport & Transportation"
        },
        {
          color: "#B84A00",
          shape: "circle",
          Icon: "manufacturing_plant",
          name: "Manufacturing Plant"
        }
      ];

    }
    function getCategoryDefaultIcon() {
      return {
        color: "#00BAAE",
        shape: "circle",
        Icon: "other",
        name: "Other"
      };
    }

    /**
     * Return Yard Id, Yard Name and ShapePointsList given the yard Id
     *  Note: in new services YardName field and ShapePointsList fields are deprecated. We will use SiteName and Polygon field.
     *  However to follow naming convention still called YardName and ShapePointsList.
     * @param {Number} yardId
     */
    function getYardByYardId(yardId) {
      var request = {
        method: "GET",
        url: daUrl + "sites/" + yardId,
      };

      return $http(request)
        .then(function (response) { //success
          var res = response.data;
          res.YardName = res.SiteName;
          res.ShapePointsList = res.Polygon;
          delete res.SiteName;
          delete res.Polygon;
          return res;
        }, function (response) { //fail
          console.log(response);
          return null;
        });
    };

    //The WS expects the last point to equal the first (it also returns the last point equal to the first)
    function yardPtsToLLArray(shapePoints) {
      var firstPoint = shapePoints[0];
      var lastPoint = shapePoints[shapePoints.length - 1];

      if (firstPoint[0] !== lastPoint[0] || firstPoint[1] !== lastPoint[1]) {
        shapePoints.push(shapePoints[0]);
      }

      return shapePoints;
    }

    function addYard({ yardName, shapePoints, siteDetail }) {
      var points = yardPtsToLLArray(shapePoints);
      var postData = {
        SiteName: yardName,
        Polygon: [points],
        SiteDetail: siteDetail
      };

      var request = {
        method: "POST",
        url: daUrl + "sites",
        data: postData
      };

      return $http(request)
        .then(function (response) { //success
          return response.data;
        }, function (response) { //fail
          console.log(response);
          return null;
        });
    };

    function deleteYard(yardId) {
      var request = {
        method: "DELETE",
        url: daUrl + "sites/" + yardId
      };

      return $http(request)
        .then(function (response) { //success
          return response.data;
        }, function (response) { //fail
          return response.data;
        });
    }

    function updateYard(yardId, { yardName, shapePoints, siteDetail }) {
      var points = yardPtsToLLArray(shapePoints);
      var putData = {
        SiteName: yardName,
        SiteID: yardId,
        Polygon: [points],
        SiteDetail: siteDetail
      };

      var request = {
        method: "PUT",
        url: daUrl + "sites",
        data: putData
      };

      return $http(request)
        .then(function (response) { //success
          return response.data;
        }, function (response) { //fail
          console.log(response);
          return null;
        });
    }

    function addPlaceToYard(yardId, placeId, returnNullOnFail) {
      var request = {
        method: "POST",
        url: daUrl + "sites/" + yardId + "/places/" + placeId
      };

      return $http(request)
        .then(function (response) { //success
          return response.data;
        }, function (response) { //fail
          // console.log(response);
          if (!returnNullOnFail) {
            return response.data;
          } else {
            return null;
          }
        });
    };

    function removeYardFromPlace(yardId, placeId) {
      var request = {
        method: "DELETE",
        url: daUrl + "sites/places/" + placeId
      };

      return $http(request)
        .then(function (response) { //success
          return response.data;
        }, function (response) { //fail
          // console.log(response);
          return response.data;
        });
    };

    function addYardGate(yardId, yardGateType, gate) {
      var plidArray = [];
      var arr = gate.plid.split(',');
      arr = _.uniq(arr);
      _.each(arr, function(p) {
        plidArray.push({"ID": p});
      });

      var postData = {
        SiteID: yardId,
        GateType: yardGateType,
        Latitude: gate.Coords.Lat,
        Longitude: gate.Coords.Lon,
        SnapLatitude: gate.SnapCoords.Lat,
        SnapLongitude: gate.SnapCoords.Lon,
        PLIDs: plidArray,
        AutoRestricted: gate.AutoRestricted,
        TruckRestricted: gate.TruckRestricted
      };

      var request = {
        method: "POST",
        url: daUrl + "sites/gates",
        data: postData
      };

      return $http(request)
        .then(function (response) { //success
          return response.data;
        }, function (response) { //fail
          console.log(response);
          return null;
        });
    };

    //Add multiple yard gates at once.
    function addYardGates(yardId, gates) {
      var promises = [];
      for (let gate of gates) {
        var promise = addYardGate(yardId, gate.Type, gate).then(function (response) {
          if (!response) {
            return null;
          }
          gate.YardGateId = response.Id;
          if (gate.NoteContent) {
            return addYardGateNote(gate, gate.NoteContent);
          } else {
            return response;
          }
        });
        promises.push(promise);
      }
      return $q.all(promises);
    }

    function deleteYardGate(gate) {
      var request = {
        method: "DELETE",
        url: daUrl + "sites/gates/" + gate.YardGateId
      };

      return $http(request)
        .then(function (response) { //success
          return response.data;
        }, function (response) { //fail
          return response.data;
        });
    }

    function updateYardGate(yardId, yardGateType, gate) {
      var plidArray = [];
      var arr = gate.plid.split(',');
      arr = _.uniq(arr);
      _.each(arr, function(p) {
        plidArray.push({"ID": p});
      });

      var putData = {
        SiteID: yardId,
        SiteGateID: gate.YardGateId,
        GateType: yardGateType,
        Latitude: gate.Coords.Lat,
        Longitude: gate.Coords.Lon,
        SnapLatitude: gate.SnapCoords.Lat,
        SnapLongitude: gate.SnapCoords.Lon,
        PLIDs: plidArray,
        AutoRestricted: gate.AutoRestricted,
        TruckRestricted: gate.TruckRestricted
      };

      var request = {
        method: "PUT",
        url: daUrl + "sites/gates",
        data: putData
      };

      return $http(request)
        .then(function (response) { //success
          return response.data;
        }, function (response) { //fail
          console.log(response);
          return null;
        });
    }

    /**
     * Get the site note list given the gate Id
     * @param {Number} gateId
     */
    function getYardGateNote(gateId) {
      var request = {
        method: "GET",
        url: daUrl + "sites/notesforgate/" + gateId,
      };

      return $http(request)
        .then(function (response) { //success
          return response.data;
        }, function (response) { //fail
          console.log(response);
          return null;
        });
    }

    function addYardGateNote(gate, note) {
      if (!note) {
        // TODO pchen: have this check in webservice
        // extra validation to prevent empty notes from getting into DA
        return null;
      }
      var postData = {
        SiteGateID: gate.YardGateId,
        NoteContent: note,
        NoteTitle: "",
        NoteIndex: 0,
        TravelIntent: gate.GateType
      };
      _.defaults(postData, DEFAULT_NOTE_FLAGS);

      var request = {
        method: "POST",
        url: daUrl + "sites/notes",
        data: postData
      };

      return $http(request)
        .then(function (response) { //success
          return response.data;
        }, function (response) { //fail
          console.log(response);
          return null;
        });
    }

    function updateYardGateNote(gate, note) {
      if (!note) {
        // TODO pchen: have this check in webservice
        // extra validation to prevent empty notes from getting into DA
        return null;
      }
      var putData = {
        NoteContent: note,
        SiteGateID: gate.YardGateId,
        SiteNoteID: gate.YardNoteId,
        NoteTitle: "",
        NoteIndex: 0,
        TravelIntent: gate.GateType
      };
      _.defaults(putData, DEFAULT_NOTE_FLAGS);

      var request = {
        method: "PUT",
        url: daUrl + "sites/notes",
        data: putData
      };

      return $http(request)
        .then(function (response) { //success
          return response.data;
        }, function (response) { //fail
          console.log(response);
          return null;
        });
    }

    function deleteYardGateNote(gate) {
      const request = {
        method: "DELETE",
        url: `${daUrl}sites/notes/${gate.YardNoteId}`
      };

      return $http(request)
        .then(response => { //success
          return response.data;
        }, response => { //fail
          console.log(response);
          return null;
        });
    }

    /**
     * Return all yard gates given the yard Id
     *  Note: the response object is quite different compared to old getYardGates function.
     * @param {number} yardId
     */
    function getYardGates(yardId) {
      var request = {
        method: "GET",
        url: daUrl + "sites/gatesforsite/" + yardId,
      };
      var deferred = $q.defer();
      $http(request)
        .then(function (response) { //success
          var yardGates = [];
          _.each(response.data, function (res) {
            res.Coords = {
              "Lon": res.Longitude,
              "Lat": res.Latitude
            };
            res.SnapCoords = {
              "Lon": res.SnapLongitude,
              "Lat": res.SnapLatitude
            };
            res.YardId = res.SiteID; // it's SiteID, not SiteId
            res.YardGateId = res.SiteGateID; // it's SiteGateID, not SiteGateId
            var plidArr = [];
            _.each(res.PLIDs, function (p) {
              plidArr.push(p.ID);
            }); // PLIDs comes in array of object.
            res.PLID = plidArr.join(",");
            res.Type = (res.GateType == null) ? 0 : res.GateType;
            res.YardGateUUId = createUniqueId(); // used as a reference key

            delete res.SiteID;
            delete res.SiteGateID;
            delete res.Longitude;
            delete res.Latitude;
            delete res.SnapLongitude;
            delete res.SnapLatitude;
            delete res.PLIDs;
            delete res.GateType;

            yardGates.push(res);
          });

          // now we have all the yard gate data, we want to get yard gate note
          var getYardGateNotePromises = [];
          _.each(yardGates, function (gate) {
            var promise = getYardGateNote(gate.YardGateId);
            getYardGateNotePromises.push(promise);
          });

          $q.all(getYardGateNotePromises)
            .then(function (yardGateNoteResponse) {
              for (var i = 0; i < yardGateNoteResponse.length; i++) {
                // each gate can have more than one notes, response is an array.
                // for now, CT only has one note per gate, so always grab the first one.
                if (yardGateNoteResponse[i] != null && yardGateNoteResponse[i][0] != null) {
                  yardGates[i].NoteContent = yardGateNoteResponse[i][0].NoteContent;
                  yardGates[i].YardNoteId = yardGateNoteResponse[i][0].SiteNoteID;
                } else {
                  yardGates[i].NoteContent = "";
                }
              }
              deferred.resolve(yardGates);
            });

        }, function (error) { //fail
          deferred.reject(error);
        });

      return deferred.promise;
    }

    function parseGateResponse(site)
    {
      var yardGates = [];

      _.each(site.SiteGates, res => {
        res.Coords = {
          "Lon": res.Longitude,
          "Lat": res.Latitude
        };
        res.SnapCoords = {
          "Lon": res.SnapLongitude,
          "Lat": res.SnapLatitude
        };
        res.YardId = res.SiteID; // it's SiteID, not SiteId
        res.YardGateId = res.SiteGateID; // it's SiteGateID, not SiteGateId
        var plidArr = [];
        _.each(res.PLIDs, function (p) {
          plidArr.push(p.ID);
        }); // PLIDs comes in array of object.
        res.PLID = plidArr.join(",");
        res.Type = (res.GateType == null) ? 0 : res.GateType;
        res.YardGateUUId = createUniqueId(); // used as a reference key

        var gateNotes = res.GateNotes;

        if (!_.isUndefined(gateNotes) && (gateNotes.length > 0)) {
          res.NoteContent = gateNotes[0].NoteContent;
          res.YardNoteId = gateNotes[0].SiteNoteID;
        } else {
          res.NoteContent = "";
        }

        res.paths = [];
        if(!_.isUndefined(res.GatePaths) && (res.GatePaths.length > 0)) {
          _.each(res.GatePaths, p => {
            var plidArr = [];

            _.each(p.PLIDs, function(plid) {
              plidArr.push(plid.ID);
            }); // PLIDs comes in array of object.

            res.paths.push({
              "yardPathId": p.SitePathID,
              "yardGateId": p.SiteGateID,
              "yardGateUUId": res.YardGateUUId,
              "yardPathUUId": createUniqueId(), // generate a UUId to be used as a reference Id
              "yardPathType": p.TravelIntent,
              "yardPathWayPoints": p.Waypoints,
              "yardPathPLIDs": plidArr,
              "isPathCurrentlyBeingEdit": false,
              // based on these values, the controller will find the full
              //   routing profile to replace this with
              "routingProfileStub": {
                "routingProfileId": p.RoutingProfileID,
                "defaultRoutingProfileKey": p.DefaultRoutingProfileKey
              }
            });
          });
        }

        delete res.SiteID;
        delete res.SiteGateID;
        delete res.Longitude;
        delete res.Latitude;
        delete res.SnapLongitude;
        delete res.SnapLatitude;
        delete res.PLIDs;
        delete res.GateType;
        delete res.GateNotes;
        delete res.GatePaths;

        yardGates.push(res);
      });

      return yardGates;
    }

    // TODO pchen: remove because it's not being used by anything
    /**
     * Return PLIDs and WayPoints and its yard gate Id given route path Id
     * @param {Number} pathId
     */
    function getYardGatePath(pathId) {
      var request = {
        method: "GET",
        url: daUrl + "sites/paths/" + pathId,
      };

      return $http(request)
        .then(function (response) { //success
          return response.data;
        }, function (response) { //fail
          console.log(response);
          return null;
        });
    }

    function constructPathPostBody(siteGateId, path) {
      const plidArray = [];
      // remove duplicates per Hugo suggests
      path.yardPathPLIDs = _.uniq(path.yardPathPLIDs);
      // TODO pchen: change all this to a .map
      _.each(path.yardPathPLIDs, p => {
        plidArray.push({"ID": p});
      });

      const postData = {
        SiteGateID: siteGateId,
        TravelIntent: path.yardPathType,
        Waypoints: path.yardPathWayPoints,
        PLIDs: plidArray
      };

      if (path.routingProfile) {
        postData.RoutingProfileID = path.routingProfile.routingProfileId;
        postData.DefaultRoutingProfileKey = path.routingProfile.defaultRoutingProfileKey;
      }

      return postData;
    }

    function addYardGatePath({ YardGateId }, path) {
      if (!path) {
        return;
      }

      const postData = constructPathPostBody(YardGateId, path);

      var request = {
        method: "POST",
        url: `${daUrl}sites/paths`,
        data: postData
      };

      return $http(request)
        .then(response => { //success
          return response.data;
        }, response => { //fail
          console.log(response);
          return null;
        });
    }

    function updateYardGatePath({ YardGateId }, path) {
      if (!path) {
        return;
      }

      const putData = constructPathPostBody(YardGateId, path);
      putData.SitePathID = path.yardPathId;

      var request = {
        method: "PUT",
        url: `${daUrl}sites/paths`,
        data: putData
      };

      return $http(request)
        .then(response => { //success
          return response.data;
        }, response => { //fail
          console.log(response);
          return null;
        });
    }

    function deleteYardGatePath(pathId) {
      var request = {
        method: "DELETE",
        url: daUrl + "sites/paths/" + pathId
      };

      return $http(request)
        .then(function (response) { //success
          return response.data;
        }, function (response) { //fail
          return response.data;
        });
    }

    /**
     * generate unique id to be used in yard gate and yard path.
     * Some gate and path have not been saved to db and got an Id yet but we still want to reference it in the code.
     */
    function createUniqueId() {
      function s4() {
        return Math.floor((1 + Math.random()) * 0x10000)
          .toString(16)
          .substring(1);
      }
      return s4() + s4() + '-' + s4() + '-' + s4() + '-' + s4() + '-' + s4() + s4() + s4();
    }

    // TODO pchen: move to separate file specifically for DA routing-profiles
    function getRoutingProfileList() {
      const request = {
        method: "GET",
        url: `${daUrl}routing-profiles/id/-1?sortBy=NAME_ASC&includeDeletedContent=false&fleetPortalRoutingProfileOnly=true&onlyMine=false`
      };

      return $http(request)
        .then(response => { //success
          return response.data;
        }, response => { //fail
          console.log(response);
          return null;
        });
    }

  }
})();




// WEBPACK FOOTER //
// ./Common Javascript Files/AngularJS/alk-places/place.cloud.service.js